import ROLES from '@/constants/roles'

export default function ({ redirect, $strapi }) {
  if (![ROLES.COMPANY, ROLES.RELINK].includes($strapi.user.role.type)) {
    return redirect('/inicio')
  }
}
